var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingIconProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CA2B2B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 43V40.3333C21 38.9188 21.5619 37.5623 22.5621 36.5621C23.5623 35.5619 24.9188 35 26.3333 35H31.6667C33.0812 35 34.4377 35.5619 35.4379 36.5621C36.4381 37.5623 37 38.9188 37 40.3333V43M38.3333 19.1733C39.4806 19.4671 40.4974 20.1343 41.2235 21.0697C41.9497 22.0052 42.3438 23.1558 42.3438 24.34C42.3438 25.5242 41.9497 26.6748 41.2235 27.6103C40.4974 28.5457 39.4806 29.2129 38.3333 29.5067M45 43V40.3333C44.9932 39.1562 44.5972 38.0144 43.8737 37.0859C43.1502 36.1573 42.1398 35.4943 41 35.2M23.6667 24.3333C23.6667 25.7478 24.2286 27.1044 25.2288 28.1046C26.229 29.1048 27.5855 29.6667 29 29.6667C30.4145 29.6667 31.771 29.1048 32.7712 28.1046C33.7714 27.1044 34.3333 25.7478 34.3333 24.3333C34.3333 22.9188 33.7714 21.5623 32.7712 20.5621C31.771 19.5619 30.4145 19 29 19C27.5855 19 26.229 19.5619 25.2288 20.5621C24.2286 21.5623 23.6667 22.9188 23.6667 24.3333Z",
    stroke: "url(#paint0_linear_2174_13703)",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2174_13703",
    x1: 21,
    y1: 31,
    x2: 45,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIconProfile);
export default __webpack_public_path__ + "static/media/pricing_icon_profile.91831db8bb6ec810d3b836e435dc78da.svg";
export { ForwardRef as ReactComponent };